module.exports = __webpack_public_path__ + "media/printed-materials/educators-03-fastwebs-app-onepage-ccd5c678.png";